import FilterOperator from "@mapmycustomers/shared/enum/FilterOperator";
import HasSourceObject from "@mapmycustomers/shared/types/base/HasSourceObject";

export const SOURCE_OBJECT_FILTER_OPERATORS = [FilterOperator.IN_ANY, FilterOperator.NONE_OF];

// antd Select cannot hold null as an option value
export const STANDARD_OPTION_VALUE = "__standard__";

// Items are not checked against the org list, so an unknown key survives a field or operator switch
export const doesSupportValue = (value: unknown, operator: FilterOperator) =>
  Array.isArray(value) &&
  value.every((item) => item === null || typeof item === "string") &&
  SOURCE_OBJECT_FILTER_OPERATORS.includes(operator);

export const toSelectValues = (keys: HasSourceObject["sourceObject"][]) =>
  keys.map((key) => key ?? STANDARD_OPTION_VALUE);

export const fromSelectValues = (values: string[]): HasSourceObject["sourceObject"][] =>
  values.map((item) => (item === STANDARD_OPTION_VALUE ? null : item));
